import moment from "moment";
import {getLocale} from 'assecobs-faktor-web-common/utils/attributesUtils';
import {getLocaleDefinition} from './localeResolver';

export const init = () => {
    moment.locale(...getLocaleDefinition(getLocale()));
};